import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { withRouter } from 'react-router-dom';

import ContactUsForm from '../../components/ContactUsForm';
import SheetTitle from '../../components/SheetTitle';
import { smoothScroll } from '../../helpers/view';

import c from './ContactUs.less';

class ContactUsComponent extends Component {
  componentDidMount() {
    smoothScroll();
  }

  handleClickOk = () => {
    this.props.history.goBack();
  };

  handleSuccess = () => {
    smoothScroll();
  };

  render() {
    return (
      <div className={c.container}>
        <Helmet defer={false}>
          <title>Contact us at Mp3Caprice</title>
          <meta property="mc:dp" content="/shop/contact-us" />
          <meta property="mc:page" content="Contact Us" />
        </Helmet>
        <SheetTitle title="Contact us" />
        <div className={c.wrapper}>
          <ContactUsForm
            defaultSubject={this.props.location.state && this.props.location.state.defaultSubject}
            onSuccess={this.handleSuccess}
            onClickOk={this.handleClickOk}
          />
        </div>
      </div>
    );
  }
}
export default withRouter(ContactUsComponent);
